export const caseSortList = [
  {
    name: '最新消息',
    param:'im_chaosong_at',
    param_name:['新-旧','旧-新'],
    param_order: ["desc","asc"]
  },
  {
    name: '患者姓名',
    param:'name',
    param_name:['A-Z','Z-A'],
    param_order: ["asc","desc"]
  },
  {
    name: '首诊日期',
    param:'sz_date',
    param_name:['新-旧','旧-新'],
    param_order: ["desc","asc"]
  },
  {
    name: '病例年龄',
    param:'age',
    param_name:['小-大','大-小'],
    param_order: ["asc","desc"]
  },
  {
    name: '最新诊疗日期',
    param:'new_date',
    param_name:['新-旧','旧-新'],
    param_order: ["desc","asc"]
  },
  {
    name: '分类',
    param:'first_case_type',
    param_name:['小-大','大-小'],
    param_order: ["asc","desc"]
  }
]
